import(/* webpackMode: "eager" */ "/opt/build/repo/app/loading.js");
